module.exports = __webpack_public_path__ + "img/29.9d538b5a.jpg";